"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CustomerGetMediaAccessibilityParams model module.
 * @module model/CustomerGetMediaAccessibilityParams
 * @version 1.1.3-alpha.1
 */
class CustomerGetMediaAccessibilityParams {
  /**
   * Constructs a new <code>CustomerGetMediaAccessibilityParams</code>.
   * @alias module:model/CustomerGetMediaAccessibilityParams
   */
  constructor() {
    CustomerGetMediaAccessibilityParams.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CustomerGetMediaAccessibilityParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CustomerGetMediaAccessibilityParams} obj Optional instance to populate.
   * @return {module:model/CustomerGetMediaAccessibilityParams} The populated <code>CustomerGetMediaAccessibilityParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CustomerGetMediaAccessibilityParams();
      if (data.hasOwnProperty('media_ids')) {
        obj['media_ids'] = _ApiClient.default.convertToType(data['media_ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CustomerGetMediaAccessibilityParams</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomerGetMediaAccessibilityParams</code>.
   */
  static validateJSON(data) {
    // ensure the json data is an array
    if (!Array.isArray(data['media_ids'])) {
      throw new Error("Expected the field `media_ids` to be an array in the JSON data but got " + data['media_ids']);
    }
    return true;
  }
}

/**
 * @member {Array.<String>} media_ids
 */
CustomerGetMediaAccessibilityParams.prototype['media_ids'] = undefined;
var _default = CustomerGetMediaAccessibilityParams;
exports.default = _default;